import { Box, FloatingButton, List, ListItemV2, Popover, State } from "@drone-js/core";
import { type FunctionComponent, useState } from "react";
import styled from "styled-components";
import { useStaticDataAtomValue } from "../../staticDataAtom";

interface Props {
    isMainPhoto: boolean;
    isHover: boolean;
    onMain?: () => void;
    onRemove?: () => void;
    hideMainPhoto: boolean;
}

const ListItem = styled(ListItemV2)`padding: 12px;`;

export const Menu: FunctionComponent<Props> = ({ isMainPhoto, isHover, onMain, onRemove, hideMainPhoto }) => {
    const [menu, setMenu] = useState(false);
    const {
        cmsData: {
            photo: { setAsMainPhoto, deleteThisPhoto },
        },
    } = useStaticDataAtomValue();

    if (menu || isHover)
        return (
            <Box position="absolute" bottom="8px" right="8px" zIndex={3}>
                <Popover
                    content={
                        <List>
                            {!hideMainPhoto && (
                                <ListItem
                                    title={setAsMainPhoto}
                                    leadingAsset={{
                                        id: "fill.symbol.pin-board",
                                    }}
                                    state={isMainPhoto && State.disabled}
                                    onClick={() => {
                                        onMain();
                                        setMenu(false);
                                    }}
                                    data-element-name="set-main-photo"
                                />
                            )}
                            <ListItem
                                title={deleteThisPhoto}
                                leadingAsset={{
                                    id: "fill.symbol.bin",
                                }}
                                onClick={onRemove}
                                data-element-name="delete-photo"
                            />
                        </List>
                    }
                    hasInteractiveContent={true}
                    pointerPosition="end-above"
                    visible={menu}
                    onVisibilityChange={setMenu}
                >
                    <FloatingButton hierarchy="tertiary" variant="icon" leadingIcon="fill.symbol.more2" size="s" />
                </Popover>
            </Box>
        );
    else return null;
};
